export const upper = (value) => value && value.toUpperCase()
export const number = (value, previousValue) => !value || (!isNaN(parseFloat(value)) && isFinite(value)) ? value : previousValue
